import type { CARDS_ASPECT_RATIO } from '../Card.h'

import { css } from '@linaria/core'
import { styled } from '@linaria/react'
import { PosterSC } from 'atoms/ImagePoster'
import { Track } from 'atoms/ProgressBar'
import { BaseCardSC, ImageBackgroundSC } from 'blocks/Cards/base-card'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'
import { CardDirection } from '../Card.h'

export const CardContainerSC = styled.div`
  position: relative;
`

export const timeLabelStyles = css`
  position: absolute;
  bottom: 0;
  right: 0;
  margin: auto 12px 12px auto;
`

export const TVShowCardWithDescriptionSC = styled.button<{
  direction?: 'row' | 'column'
  width?: string
  posterWidth?: string
  posterAspectRatio: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  background?: COLOR
  backgroundHovered?: COLOR
  backgroundPressed?: COLOR
  backgroundSelected?: COLOR
  isSelected: boolean
  paddings?: FIXED_INDENTS[]
  gap?: FIXED_INDENTS
}>`
  &[data-arcana-button='true'] {
    display: flex;
    flex-direction: ${({ direction }) => direction || CardDirection.Horizontal};
    width: ${({ width }) => width || '100%'};
    background-color: ${({
      background = COLOR.TRANSPARENT,
      backgroundSelected = COLOR.SURFACE_OPACITY_LIGHT_10,
      isSelected,
    }) => `var(${!isSelected ? background : backgroundSelected})`};
    cursor: pointer;
    transition: background-color 0.25s linear;
    border: none;

    padding: var(${FIXED_INDENTS.INDENT_40}) var(${FIXED_INDENTS.INDENT_50});
    gap: 16px;

    ${MEDIA.MIN_600} {
      padding: var(${FIXED_INDENTS.INDENT_50}) var(${FIXED_INDENTS.INDENT_60});
      gap: 20px;
    }

    ${MEDIA.MIN_1240} {
      padding: var(${FIXED_INDENTS.INDENT_60}) var(${FIXED_INDENTS.INDENT_80});
      gap: 24px;
    }

    ${BaseCardSC} {
      ${ImageBackgroundSC} {
        ${PosterSC} {
          object-fit: cover;
        }
      }
    }

    ${BaseCardSC} {
      position: relative;
      width: ${({ posterWidth }) => (posterWidth ? posterWidth : '100%')};
      flex: 0 0 auto;
      height: ${({ posterWidth, posterAspectRatio }) =>
        `calc(${posterWidth} / ${posterAspectRatio})`};

      ${Track} {
        /* progress line */
        position: absolute;
        bottom: 0px;
      }
    }

    ${MEDIA.NO_TOUCH} {
      &:hover {
        background-color: ${({
          backgroundHovered = COLOR.SURFACE_OPACITY_LIGHT_15,
        }) => `var(${backgroundHovered})`};
      }
    }

    &:focus {
      background-color: ${({
        backgroundPressed = COLOR.SURFACE_OPACITY_LIGHT_20,
      }) => `var(${backgroundPressed})`};
    }
  }
`

export const DescriptionBlockSC = styled.div<{
  textPaddings?: FIXED_INDENTS[]
}>`
  overflow: hidden;
  margin: auto 0;
  padding: ${({ textPaddings }) =>
    textPaddings?.map((textPadding) => `var(${textPadding})`).join(' ') || 0};
`
